import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";

export const determineLoanMessage = (downPaymentAmt, totalCurrentCarLoanAmt,
        maxDownPayment, newLoanRequired, tradeInOption, applyTradeIn, addToCashAmt, tradeInAmt) => {
    let loanMessage = "";
    if (downPaymentAmt === totalCurrentCarLoanAmt && totalCurrentCarLoanAmt > 0){
            loanMessage= "Amount of cash down will pay off the current car loan.";
          }else{
            if (downPaymentAmt === maxDownPayment){
                if (totalCurrentCarLoanAmt === 0){
                    loanMessage= "Amount of cash down will pay for new car outright " +
                        "(no loan required)."
                }else{
                    loanMessage= "Amount of cash down will pay off current loan and " +
                        "purchase the car outright (no new loan required)."
                }
            }else{
                if (totalCurrentCarLoanAmt === 0){
                    if (downPaymentAmt === 0){
                        loanMessage = "A car loan will be created for this purchase.";
                    }else{
                        loanMessage= "Amount of cash down will reduce the amount of the new car loan."
                    }
                }else{
                    if (newLoanRequired === true){
                        loanMessage=  "Your current car loan will be closed out and a new " +
                          "loan will be created."; 
                    }else{
                        if (tradeInOption === true){
                            if (applyTradeIn === true){
                                loanMessage = "Your current car loan will be closed out.";
                            }
                            if (addToCashAmt > 0){
                                loanMessage += "..and, " + doubleToStringMonthly(this.addToCashAmt) +
                                    " will be added to your cash."
                            }
                        }else{
                            loanMessage = "The trade-in value for your current car ";
                            if (downPaymentAmt > 0){
                                loanMessage += " plus the 'Cash Down Amount' ";
                            }
                            loanMessage += "will be applied to "
                            if (tradeInAmt > totalCurrentCarLoanAmt){
                                loanMessage += "pay off your current car loan";
                            }else{
                                 loanMessage += "reduce the amount of the current car loan.";
                            }
                        }
                      }
                  }
                }
          }
    return loanMessage;
}
export default determineLoanMessage;